"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("react-bootstrap/lib");

var _lodash = require("lodash");

var _pluralize = _interopRequireDefault(require("pluralize"));

var _urijs = _interopRequireDefault(require("urijs"));

var _Main = _interopRequireDefault(require("./genes/Main.js"));

var _Main2 = require("./column-filters/Main.js");

var _Cutoff = _interopRequireDefault(require("./Cutoff.js"));

var _CutoffDistribution = _interopRequireDefault(require("./CutoffDistribution.js"));

var _Regulation = _interopRequireDefault(require("./Regulation.js"));

var _Unit = _interopRequireDefault(require("./Unit.js"));

var _Specificity = _interopRequireDefault(require("./Specificity.js"));

var _PropTypes = require("./PropTypes.js");

require("./bootstrap-toggle.min.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var prettyName = function prettyName(name) {
  return name.replace(/_/g, " ").toLowerCase().replace(/\w\S*/, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

var OpenerButton = function OpenerButton(_ref) {
  var onClickButton = _ref.onClickButton;
  return /*#__PURE__*/_react["default"].createElement(_lib.Button, {
    bsSize: "large",
    onClick: onClickButton,
    style: {
      textTransform: "unset",
      letterSpacing: "unset",
      height: "unset"
    }
  }, /*#__PURE__*/_react["default"].createElement(_lib.Glyphicon, {
    glyph: "equalizer"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      verticalAlign: "middle"
    }
  }, " Select"));
};

OpenerButton.propTypes = {
  onClickButton: _propTypes["default"].func.isRequired
};

var ModalWrapper = function ModalWrapper(_ref2) {
  var title = _ref2.title,
      show = _ref2.show,
      onCloseModal = _ref2.onCloseModal,
      onClickApply = _ref2.onClickApply,
      children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(_lib.Modal, {
    show: show,
    onHide: onCloseModal,
    bsSize: "large"
  }, /*#__PURE__*/_react["default"].createElement(_lib.Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/_react["default"].createElement(_lib.Modal.Title, null, title)), /*#__PURE__*/_react["default"].createElement(_lib.Modal.Body, null, children), /*#__PURE__*/_react["default"].createElement(_lib.Modal.Footer, null, onClickApply && /*#__PURE__*/_react["default"].createElement(_lib.Button, {
    bsStyle: "primary",
    onClick: onClickApply,
    style: {
      textTransform: "unset",
      letterSpacing: "unset",
      height: "unset"
    }
  }, "Apply"), /*#__PURE__*/_react["default"].createElement(_lib.Button, {
    onClick: onCloseModal,
    style: {
      textTransform: "unset",
      letterSpacing: "unset",
      height: "unset"
    }
  }, "Close")));
};

ModalWrapper.propTypes = {
  show: _propTypes["default"].bool.isRequired,
  onCloseModal: _propTypes["default"].func.isRequired,
  onClickApply: _propTypes["default"].func
};

var determineAvailableColumns = function determineAvailableColumns(columnGroups) {
  return _lodash.intersection.apply([], columnGroups.map(function (group) {
    return _lodash.union.apply([], group.groupings.map(function (g) {
      return g[1];
    }));
  }));
};

var determineColumnNameFromFirstGroup = function determineColumnNameFromFirstGroup(availableColumnIds, group) {
  var groupingValues = group.groupings.map(function (g) {
    return g[1];
  });

  if ((0, _lodash.isEqual)(new Set(availableColumnIds), new Set([].concat.apply([], groupingValues))) && groupingValues.every(function (ids) {
    return ids.length === 1;
  })) {
    return (0, _pluralize["default"])(prettyName(group.name));
  } else {
    return "";
  }
};

var Header = function Header(_ref3) {
  var text = _ref3.text;
  return /*#__PURE__*/_react["default"].createElement("h4", null, text);
};

var SidebarAndModal = /*#__PURE__*/function (_React$Component) {
  _inherits(SidebarAndModal, _React$Component);

  var _super = _createSuper(SidebarAndModal);

  function SidebarAndModal(props) {
    var _this;

    _classCallCheck(this, SidebarAndModal);

    _this = _super.call(this, props);
    _this.state = {
      showModal: "",
      geneQuery: _this.props.queryObjects.geneQuery,
      selectedColumnIds: _this.props.queryObjects.selectedColumnIds,
      initialFilters: true
    };
    return _this;
  }

  _createClass(SidebarAndModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var showRegulation = ["UP", "DOWN", "UP_DOWN"].includes(this.props.queryObjects.regulation);
      var availableColumnIds = determineAvailableColumns(this.props.columnGroups);
      var maybeColumnsName = this.props.isDifferential ? "Comparisons" : determineColumnNameFromFirstGroup(availableColumnIds, this.props.columnGroups[0]);
      var heatmapColumns = {
        columnGroups: this.props.columnGroups,
        selectedColumnIds: this.state.selectedColumnIds,
        availableColumnIds: availableColumnIds,
        columnsName: maybeColumnsName || "Sample groups"
      };

      var onChangeProperty = function onChangeProperty(name, newValue) {
        var newQueryObjects = Object.assign({}, _this2.props.queryObjects);
        newQueryObjects[name] = newValue;
        return _this2.props.onChangeQueryObjects(newQueryObjects);
      };

      var toggleModal = function toggleModal(which) {
        return _this2.setState({
          showModal: which || ""
        });
      };

      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(Header, {
        text: "Genes"
      }), /*#__PURE__*/_react["default"].createElement(_Main["default"], {
        geneSuggesterUri: this.props.geneSuggesterUri,
        geneQuery: this.state.geneQuery,
        onChangeGeneQuery: function onChangeGeneQuery(geneQuery) {
          _this2.setState({
            geneQuery: geneQuery
          });
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row column margin-top-large"
      }, /*#__PURE__*/_react["default"].createElement(_lib.Button, {
        onClick: onChangeProperty.bind(null, "geneQuery", this.state.geneQuery),
        style: {
          textTransform: "unset",
          letterSpacing: "unset",
          height: "unset",
          marginRight: "1rem"
        }
      }, "Apply"), /*#__PURE__*/_react["default"].createElement(_lib.Button, {
        onClick: function onClick() {
          return _this2.setState({
            geneQuery: []
          });
        },
        style: {
          textTransform: "unset",
          letterSpacing: "unset",
          height: "unset"
        }
      }, "Clear")), /*#__PURE__*/_react["default"].createElement(_Specificity["default"], {
        specific: this.props.queryObjects.specific,
        onChangeSpecific: onChangeProperty.bind(null, "specific")
      }), showRegulation && /*#__PURE__*/_react["default"].createElement(_Regulation["default"], {
        regulation: this.props.queryObjects.regulation,
        onChangeRegulation: onChangeProperty.bind(null, "regulation")
      }), /*#__PURE__*/_react["default"].createElement(_Cutoff["default"], {
        cutoff: this.props.queryObjects.cutoff,
        onChangeCutoff: onChangeProperty.bind(null, "cutoff")
      }), this.props.genesDistributedByCutoffUrl && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "#",
        onClick: toggleModal.bind(null, "cutoff"),
        style: {
          marginBottom: "0.5rem",
          fontSize: "85%"
        }
      }, /*#__PURE__*/_react["default"].createElement(_lib.Glyphicon, {
        glyph: "stats"
      }), /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          marginLeft: "0.25rem"
        }
      }, "See distribution")), /*#__PURE__*/_react["default"].createElement(ModalWrapper, {
        title: "Cutoff - distribution of genes",
        show: this.state.showModal === "cutoff",
        onCloseModal: function onCloseModal() {
          _this2.setState({
            showModal: ""
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_CutoffDistribution["default"], {
        cutoff: this.props.queryObjects.cutoff,
        unit: this.props.queryObjects.unit,
        onChangeCutoff: (0, _lodash.flow)([onChangeProperty.bind(null, "cutoff"), toggleModal.bind(null, "")]),
        genesDistributedByCutoffUrl: this.props.genesDistributedByCutoffUrl
      }))), !!this.props.availableDataUnits.length && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(Header, {
        text: "Data units"
      }), /*#__PURE__*/_react["default"].createElement(_Unit["default"], {
        unit: this.props.queryObjects.unit,
        available: this.props.availableDataUnits,
        onChangeUnit: onChangeProperty.bind(null, "unit")
      })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(Header, {
        text: maybeColumnsName || "Experimental variables"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row column margin-bottom-medium"
      }, /*#__PURE__*/_react["default"].createElement(OpenerButton, {
        onClickButton: toggleModal.bind(null, "columns")
      })), /*#__PURE__*/_react["default"].createElement(_Main2.Summary, heatmapColumns), /*#__PURE__*/_react["default"].createElement(ModalWrapper, {
        title: maybeColumnsName || "Experimental variables",
        show: this.state.showModal === "columns",
        onCloseModal: function onCloseModal() {
          _this2.setState({
            showModal: "",
            selectedColumnIds: _this2.props.queryObjects.selectedColumnIds
          });
        },
        onClickApply: (0, _lodash.flow)([toggleModal.bind(null, ""), this.setState.bind(this, {
          initialFilters: this.state.initialFilters && (0, _lodash.xor)(this.state.selectedColumnIds, this.props.queryObjects.selectedColumnIds).length === 0
        }), onChangeProperty.bind(null, "selectedColumnIds", this.state.selectedColumnIds)])
      }, /*#__PURE__*/_react["default"].createElement(_Main2.Main, _extends({}, heatmapColumns, {
        isDifferential: this.props.isDifferential,
        onNewSelectedColumnIds: function onNewSelectedColumnIds(selectedColumnIds) {
          _this2.setState({
            selectedColumnIds: selectedColumnIds
          });
        }
      }))), this.props.defaultQuery && this.state.initialFilters && /*#__PURE__*/_react["default"].createElement("div", {
        className: "margin-top-medium"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "margin-bottom-small"
      }, "Initially showing:"), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "small"
      }, this.props.columnGroups.filter(function (group) {
        return group.groupings.length > 1;
      }).map(function (group) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: group.name
        }, prettyName(group.name), ": ", group.selected);
      }))));
    }
  }]);

  return SidebarAndModal;
}(_react["default"].Component);

SidebarAndModal.propTypes = {
  isDifferential: _propTypes["default"].bool.isRequired,
  geneSuggesterUri: _propTypes["default"].instanceOf(_urijs["default"]),
  defaultQuery: _propTypes["default"].bool.isRequired,
  genesDistributedByCutoffUrl: _propTypes["default"].string.isRequired,
  loadingGifUrl: _propTypes["default"].string.isRequired,
  columnGroups: _propTypes["default"].arrayOf(_propTypes["default"].shape(_PropTypes.ColumnGroupPropTypes)).isRequired,
  availableDataUnits: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired).isRequired,
  queryObjects: _propTypes["default"].shape(_PropTypes.QueryObjectsPropTypes).isRequired,
  onChangeQueryObjects: _propTypes["default"].func.isRequired
};
var _default = SidebarAndModal;
exports["default"] = _default;